import { render } from "./InspectionInfoForm.vue?vue&type=template&id=cf1b26ca"
import script from "./InspectionInfoForm.vue?vue&type=script&lang=js"
export * from "./InspectionInfoForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__